import MineComponent from '@/view/mine'
const MINE = {
  name: 'mine',
  component: MineComponent,
  meta: {
    title: 'mine',
    keepAlive: true // 需要被缓存
  }
}
export default MINE
